export default [
  {
    countryCode: "US",
    farAwayThreshold: 25,
    finderRoute: "/cbd-stores",
    storeRoute: "/cbd-store/",
    title: "CBD",
    type: "cbd-store",
  },
  {
    countryCode: "CA",
    farAwayThreshold: 40.2336,
    finderRoute: "/medical-marijuana-doctors",
    storeRoute: "/doctors/",
    title: "Doctors",
    type: "clinic",
  },
  {
    countryCode: "US",
    farAwayThreshold: 25,
    finderRoute: "/medical-marijuana-doctors",
    storeRoute: "/doctors/",
    title: "Doctors",
    type: "clinic",
  },
  {
    countryCode: "CA",
    farAwayThreshold: 40.2336,
    finderRoute: "/dispensaries",
    storeRoute: "/cannabis-store/",
    title: "Stores",
    type: "dispensary",
  },
  {
    countryCode: "US",
    farAwayThreshold: 25,
    finderRoute: "/dispensaries",
    storeRoute: "/dispensary-info/",
    title: "Dispensaries",
    type: "dispensary",
  },
];
